import { useEffect } from "react";
import { useRequest } from "hooks/useRequest";
import api from "utils/api";
import type {
  UploadFileRow,
  UseUnfinishedUploadFilesArgs,
  UseUnfinishedUploadFilesResult,
} from "./types";

const POLL_INTERVAL_MS = 30_000;

export const useUnfinishedUploadFiles = ({
  projectId,
}: UseUnfinishedUploadFilesArgs): UseUnfinishedUploadFilesResult => {
  const {
    data,
    isLoading,
    run: runFetch,
  } = useRequest<{ files: UploadFileRow[] } | undefined, []>(
    async () => {
      if (!projectId) return undefined;
      return api.getQuantitySurveyorUnfinishedUploadFiles(projectId);
    },
    { manual: true },
  );

  const files = data?.files ?? [];

  useEffect(() => {
    if (!projectId) return;
    runFetch();
  }, [projectId, runFetch]);

  useEffect(() => {
    if (!projectId || files.length === 0) return;
    const intervalId = setInterval(() => {
      runFetch();
    }, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [projectId, files.length, runFetch]);

  return { files, isLoading, refetch: runFetch };
};
